import * as types from './mutation-types.js';

const mutations = {
	[types.SET_TOKEN] (state, token) {
		state.token = token;
	},
	[types.SET_BACK_URL] (state, backurl) {
		state.backurl = backurl;
	},
	[types.SET_USERINFO] (state, userInfo) {
		state.user = userInfo;
	},
	[types.SET_WX_URL] (state, url) {
		state.wxUrl = url;
	},
	[types.SET_VERIFY_CODE_TIME] (state, time) {
		state.verifyCodeTime = time;
	},
	[types.SET_VERIFY_CODE_STATE] (state, bool) {
		state.isVerifyCodeReady = bool;
	},
	[types.RESET_CLASS_STATE] (state) {
		state.isStartClass = false;
		state.isEndClass = false;
		state.startClassRecordId = '';
	},
	[types.SET_START_CLASS] (state) {
		state.isStartClass = true;
		state.isEndClass = false;
	},
	[types.SET_END_CLASS] (state) {
		state.isEndClass = true;
		state.isStartClass = false;
		state.startClassRecordId = '';
	},
	[types.SET_START_CLASS_RECORDID] (state, recordId) {
		state.startClassRecordId = recordId;
	},
	[types.SET_LOADING_COUNT] (state, count) {
		state.loadingCount = count;
	}
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js